import type { TextareaHTMLAttributes } from "preact/compat";
import type { FormFieldProps } from "./form-field.tsx";
import FormField from "./form-field.tsx";
import classes from "./inputs-shared.module.css";

type TextareaFieldProps = Pick<FormFieldProps, "label" | "className"> & {
	readonly name: string;
} & Pick<
		TextareaHTMLAttributes<HTMLInputElement>,
		"placeholder" | "disabled" | "required" | "rows" | "minLength"
	>;

function TextareaField({
	label,
	name,
	className,
	...rest
}: TextareaFieldProps) {
	const fieldId = `${name}-field`;
	return (
		<FormField fieldId={fieldId} label={label} className={className}>
			<textarea
				id={fieldId}
				name={name}
				className={classes["input"]}
				{...rest}
			/>
		</FormField>
	);
}

export default TextareaField;
